import { combineReducers } from 'redux';
import { createDataReducer } from '../../store/dataReducer';
import { createRequestReducer } from '../../store/requestReducer';
import * as actions from './reportsActions';

export const initialFilterState = {
  statusActive: true,
  statusClosed: true,
  statusDropped: true,
  statusLocked: true,
  statusConditionally: true,
  storeNumber: '',
  sequenceNumber: '',
  projectName: '',
  city: '',
  state: '',
  discretionaryApproval: null,
  page: 0,
  rowsPerPage: 10,
};

export function filtersReducer(state = initialFilterState, action = {}) {
  switch (action.type) {
    case actions.SET_FILTER:
      return {
        ...state,
        [action.filterKey]: action.filterValue,
      };
    case actions.SET_PAGE:
      return {
        ...state,
        page: action.page,
        rowsPerPage: action.rowsPerPage !== undefined ? action.rowsPerPage : state.rowsPerPage,
      };
    case actions.RESET_FILTER:
      return initialFilterState;
    default:
      return state;
  }
}

export function totalCountReducer(state = 0, action = {}) {
  switch (action.type) {
    case actions.SET_TOTAL_COUNT:
      return action.count;
    default:
      return state;
  }
}

export function discApprovalCountReducer(state = 0, action = {}) {
  switch (action.type) {
    case actions.SET_DISC_APPROVAL_COUNT:
      return action.count;
    default:
      return state;
  }
}

export function filteredProjectsReducer(state = [], action = {}) {
  switch (action.type) {
    case actions.SET_FILTERED_PROJECTS:
      return action.data;
    default:
      return state;
  }
}

export function allFilteredClosingIdsReducer(state = [], action = {}) {
  switch (action.type) {
    case actions.SET_ALL_FILTERED_CLOSING_IDS:
      return action.ids;
    case actions.RESET_FILTER:
      return [];
    default:
      return state;
  }
}

export function bulkReportStatusReducer(state = { success: false, error: null, reportType: null, selectedColumns: null }, action = {}) {
  switch (action.type) {
    case actions.GENERATE_BULK_REPORT:
      return { success: false, error: null, reportType: action.reportType, selectedColumns: action.selectedColumns };
    case actions.BULK_REPORT_SUCCESS:
      return { success: true, error: null, reportType: action.reportType, selectedColumns: action.selectedColumns };
    case actions.BULK_REPORT_ERROR:
      return { success: false, error: action.message, reportType: null, selectedColumns: null };
    case actions.CLEAR_BULK_REPORT_STATUS:
      return { success: false, error: null, reportType: null, selectedColumns: null };
    default:
      return state;
  }
}

export function exportLoadingReducer(state = false, action = {}) {
  switch (action.type) {
    case actions.EXPORT_LOADING:
      return action.loading;
    default:
      return state;
  }
}

export default combineReducers({
  data: createDataReducer({
    SET_DATA: actions.SET_DATA,
  }),
  request: createRequestReducer({
    ERROR: actions.ERROR,
    LOADING: actions.LOADING,
  }),
  filters: filtersReducer,
  totalCount: totalCountReducer,
  discApprovalCount: discApprovalCountReducer,
  filteredProjects: filteredProjectsReducer,
  allFilteredClosingIds: allFilteredClosingIdsReducer,
  bulkReportStatus: bulkReportStatusReducer,
  exportLoading: exportLoadingReducer,
});
